<template>
  <transition name="loader-transition" appear>
    <div class="o-loader">
      <div class="o-loader__ring"><div></div><div></div><div></div><div></div></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TheLoader'
};
</script>
